import React, { FC } from "react";
import LibraryItemActiveClientsAvatarStack from "@src/features/contentLibrary/LibraryItemActiveClientsAvatarStack";
import useActiveClients from "@src/features/libraryItem/hooks/useActiveClients";

type Props = {
  size?: number;
};

const BuilderActiveClientsStack: FC<Props> = ({ size = 32 }) => {
  const { activeClients } = useActiveClients();
  if (!activeClients?.length) return null;
  return (
    <LibraryItemActiveClientsAvatarStack
      activeClients={activeClients}
      size={size}
    />
  );
};

export default BuilderActiveClientsStack;
